import { ReactElement, useEffect } from 'react';
import { useUINav } from '@/ui';
import { useCompanyContext, useTeam } from '@/companies/providers';
import {
    GeneralTeamSettingsSection,
    TeamAdminSettingsSection,
    TeamContactsScheduleSettingsSection,
    TeamContactsSettingsSection,
    TeamOutOfHoursSettingsSection,
    TeamProceduresSettingsSection,
    TeamTaskSettingsSection
} from '@/companies/components';
import { useTeamPermissions } from '@/companies/hooks';
import { usePagesTranslation } from '../../hooks';

export function TeamIdGeneralSettingsPage(): ReactElement {
    const { t } = usePagesTranslation();
    const { company } = useCompanyContext();
    const { team } = useTeam();

    const { setParts } = useUINav();
    useEffect(() => {
        setParts([
            {
                text: t('shared.labels.settings')
            },
            {
                text: t('shared.labels.teams'),
                link: `/company/${company.id}/settings/teams`
            },
            { text: team.name },
            { text: t('shared.labels.general') }
        ]);
    }, [setParts, company.id, team.name, t]);

    const { canEditTeam } = useTeamPermissions({
        teamId: team.id
    });

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
            <GeneralTeamSettingsSection team={team} />
            <TeamTaskSettingsSection team={team} />
            <TeamContactsSettingsSection team={team} />
            <TeamContactsScheduleSettingsSection team={team} />
            <TeamOutOfHoursSettingsSection team={team} />
            <TeamProceduresSettingsSection team={team} />
            {canEditTeam && <TeamAdminSettingsSection team={team} />}
        </div>
    );
}
